import React from 'react';
import { ReactReadyWrapper } from './ReactReadyWrapper';
import StartupDashboard from './StartupDashboard';
import SaaSInvestmentCalculator from './SaaSInvestmentCalculator';

const AppWrapper: React.FC = () => {
  // Simple component that doesn't use hooks to avoid React initialization issues
  // Check URL params synchronously
  const hasStartupId = typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('startupId') !== null;

  return (
    <ReactReadyWrapper>
      {hasStartupId ? <SaaSInvestmentCalculator /> : <StartupDashboard />}
    </ReactReadyWrapper>
  );
};

export default AppWrapper;